import { render, staticRenderFns } from "./CarePlan.vue?vue&type=template&id=f6ef95c2"
import script from "./CarePlan.vue?vue&type=script&lang=ts"
export * from "./CarePlan.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports